import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Badge} from 'reactstrap'
import {Link} from 'react-router-dom'

import './PurchaserSearchListItem.scss'

export default class PurchaserSearchListItem extends PureComponent {
  static propTypes = {
    generateLink: PropTypes.func.isRequired,
    offset: PropTypes.number.isRequired,
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),//false => no data
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
  }

  render() {
    const {generateLink, offset, score, user} = this.props
    const trimmedFullname = (user?.fullname ?? '').trim()

    return (
      <li className="col-md-12 purchaser-search-list-item p-2">
        <Link to={generateLink(user, offset)}>
          <div className="d-flex align-items-center flex-column flex-lg-row justify-content-between">
            <div className="d-flex align-items-center flex-column flex-lg-row">
              <h6 className="name mx-lg-1">{trimmedFullname === '' ? '???' : trimmedFullname}</h6>
              <p className="job">
                {this.props.user.fonction ? this.props.user.fonction : ''}
                {this.props.user.company ? ` @${this.props.user.company}` : ''}
              </p>
              <div className="d-flex flex-column flex-lg-row align-items-center">
                <div className="d-flex align-items-center justify-content-around">
                  <Badge color="light">User #{user.id}</Badge>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center">
              {score ? <Badge color="light">Score: {Math.round(score)}</Badge> : ''}
            </div>
          </div>
        </Link>
      </li>
    )
  }
}